export default __webpack_public_path__ + "static/media/KahshExchange.0ae0d9a4.png";